// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/loading/index.css
// module id = 48
// module chunks = 1 2 6